import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { MyErrorStateMatcher, ValidatorConfig } from '../../../../../../common/field-validation/my-error-state-matcher';
import { UiValidator } from '../../../../../../common/field-validation/ui-validator.dto';

@Component({
  selector: 'app-form-field-text',
  templateUrl: './text-form-field.component.html',
  styleUrls: ['./text-form-field.component.scss'],
  standalone: false,
})
export class TextFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  ellipsis = false;

  matcher = new MyErrorStateMatcher();

  ngOnDestroy() {}

  condition(v: UiValidator) {
    const formControl = this.getFormControl();
    return this.getValidatorConfig(v).condition(formControl);
  }

  message(v: UiValidator) {
    return this.getValidatorConfig(v).message(v);
  }

  private getValidatorConfig(v: UiValidator): ValidatorConfig {
    return MyErrorStateMatcher.messageMap[v.type];
  }

  private getFormControl(): AbstractControl {
    return this.formGroup.get(this.fieldConfig.name);
  }

  ngOnInit(): void {
    this.initialise();
    this.ellipsis = !!this.fieldConfig?.ellipsisMaxWidth;
  }

  getType() {
    return this.fieldConfig.type === 'number' ? 'number' : 'text';
  }

  onEllipsisClick(): void {
    if (this.fieldConfig?.ellipsisMaxWidth) {
      this.ellipsis = !this.ellipsis;
    }
  }
}
